import { h1, h3, h4 } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  margin-top: 50px;

  @media ${({ theme }) => theme.breakpoints.md} {
    display: none;
  }
`;

const H1 = styled(h1)`
  color: ${({ theme }) => theme.textColors.secondary};
  margin-top: 20px;
`;

const H3 = styled(h3)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.textColors.secondary};
`;

const H4 = styled(h4)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.textColors.secondary};
  margin-bottom: 10px;
`;

const EventWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  height: 178px;
  width: 381px;
  display: flex;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  width: 50%;
  height: 100%;
  text-align: center;
`;

const S = {
  Container,
  H3,
  H4,
  EventWrapper,
  ContentWrapper,
  H1,
};

export default S;
